<div [dir]="direction">
  <router-outlet *ngIf="!isMobile && !showNavigationPopup"></router-outlet>
  <div *ngIf="showSpinner" class="ct-overlay">
    <app-spinner></app-spinner>
  </div>
</div>
<div *ngIf="isMobile || showNavigationPopup" class="get-mobile-app">
  <div class="column-align-center">
    <img src="assets/images/clickit-build-thrive.svg" alt="" />
    <p class="get-mobile-app-msg" *ngIf="showNavigationPopup">
      {{ "WeVeMovedToANewLink" | translate }}
      <a href="javascript:void(0)" (click)="NavigateToAWS('anchor')">{{"https://web.clickitapp.io"}}</a>
      {{ "PleaseBookmarkTheNewLink" | translate }}
    </p>
    <p class="get-mobile-app-msg" *ngIf="isMobile">
      {{
        "SorryTheClickitWebAppIsNotOptimizedForMobilePhoneScreensButWeDoHaveMobileAppsDesignedSpeciallyForBothAndroidAndIPhonesOnGooglePlayStoreAndAppleAppStoreRespectively"
          | translate
      }}
    </p>
    <div class="row-align-center" *ngIf="isMobile">
      <a href="https://apps.apple.com/us/app/clickit/id1615341953"
        ><img class="app-on-icon" src="assets/images/app-store.svg" alt=""
      /></a>
      <a
        href="https://play.google.com/store/apps/details?id=com.holcim.navendor"
        ><img class="app-on-icon" src="assets/images/google-play.svg" alt=""
      /></a>
    </div>
    <div class="row-align-center" *ngIf="showNavigationPopup">
      <button class="act-btn-dark" (click)="NavigateToAWS('button')">{{ "GoThereNow!" | translate }}</button>
    </div>
  </div>
</div>

<div *ngIf="showError">
  <app-error-modal></app-error-modal>
</div>
<app-update-app-modal [updatedStaus]="versionUpadted"></app-update-app-modal>

 <!-- migration popup -->
 <div class="ct-overlay migarion-pop-common-overlay" *ngIf="isHolcimUser">
  <div class="ct-modal migarion-pop-common">
   
    <div class="ct-mdl-cont">
      <div class="migarion-pop-content-common">
        <img src="assets/images/clickit-build-thrive.svg" alt="" />
        <div class="ct-mdl-wrap">
          <p class="clickit-migarion-subtext-common">{{"ThisAppIsNotAvailableForYou"| translate}}</p>
          <p class="clickit-migarion-subtext-small-common">{{"PleaseContinueOn" | translate }} <span class="clickit-migarion-subtext-small-common-bold">HOLCIM+</span> {{"ToEnjoyTheSameHighQualityServiceAndMore" | translate}}</p>

          <div class="hzvt-item-center hzvt-item-center modal-foot-btns">
            <button class="btn-dark-migarion-common" (click)="movetoHolcim($event)">
              {{ "ContinueOn" | translate }} HOLCIM+
            </button>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</div>
<!-- migration popup -->